import React, { useState } from 'react';
import { TicketIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { getConfig } from '../services/configManager';
import { useAppState } from '../hooks/useAppState';
import ValidationModal from './ValidationModal';

const CouponCard: React.FC = () => {
  const config = getConfig();
  const enabled = config.FEATURES.Coupon?.Enabled ?? true;
  const { state, setAppliedCouponCode } = useAppState();

  const [modalOpen, setModalOpen] = useState(false);

  if (!enabled) return null;

  const ticketId = state.currentTicket?.ticketId
    ? Number(state.currentTicket.ticketId)
    : 0;

  const handleApplied = (code: string) => {
    setAppliedCouponCode(code);
    setModalOpen(false);
  };

  if (state.appliedCouponCode) {
    return (
      <div className="flex items-center gap-2.5 w-full px-3 py-2.5 my-1 bg-green-50 border border-green-200 rounded-[9px] cursor-default select-none">
        <span className="flex-none flex text-green-600">
          <TicketIcon className="w-4 h-4" />
        </span>
        <span className="flex-1 text-left">
          <span className="block text-[13px] font-semibold text-green-800">
            Validation applied
          </span>
          <span className="block text-[11.5px] font-bold text-green-700 mt-px">
            code: {state.appliedCouponCode}
          </span>
        </span>
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setModalOpen(true)}
        className="flex items-center gap-2.5 w-full px-3 py-2.5 my-1 bg-blue-50 border border-blue-100 rounded-[9px] cursor-pointer select-none transition-all duration-150 hover:bg-blue-100 hover:border-blue-200 hover:shadow-md active:scale-[0.985] focus-visible:outline-2 focus-visible:outline-primary-btn focus-visible:outline-offset-2"
      >
        <span className="flex-none flex text-primary-btn">
          <TicketIcon className="w-4 h-4" />
        </span>
        <span className="flex-1 text-left">
          <span className="block text-[13px] font-semibold text-black">
            I have a validation
          </span>
          <span className="block text-[11.5px] font-medium text-text-disabled mt-px">
            Sticker or coupon
          </span>
        </span>
        <ChevronRightIcon className="flex-none w-4 h-4 text-primary-btn" />
      </button>

      <ValidationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onApplied={handleApplied}
        ticketId={ticketId}
      />
    </>
  );
};

export default CouponCard;
